<template>
  <div class="footer">
    <div class="content">
      <div class="top">
        <img src="../assets/littleLogo.png" alt="" />
        <h1>
          公司作为专业从事企业级移动互联平台产品研发的高新技术企业，
          致力于将移动互联世界的理念、技术和用户体验引入2B领域。
        </h1>
      </div>
      <div class="bottom">
        <p>
          北京德惠众合信息技术有限公司 版权所有 京ICP备14012220号-5 版权所有
        </p>
        <p>
          Copyright © 2022 Beijing Dehui Network CO.,LTD. ALL RIGHTS RESERVED
        </p>
      </div>
    </div>
    <div class="mobile_content">
      <CollapsiblePanel
        title="房源列表"
        :arrow-images="[arrowRight]"
        :static-arrow="true"
        @click.native="goToPropertie"
      />
      <CollapsiblePanel
        title="热门项目"
        :arrow-images="[arrowRight, arrowBottom]"
        :static-arrow="false"
      >
        <template #content>
          <ul>
            <li @click="goToImmigration">移民项目</li>
            <li>留学教育</li>
            <li>境外生活</li>
            <li>资讯百科</li>
          </ul>
        </template>
      </CollapsiblePanel>
      <div class="introductory">
        <img src="../assets/littleLogo.png" alt="" />
        <h1>
          公司作为专业从事企业级移动互联平台产品研发的高新技术企业，
          致力于将移动互联世界的理念、技术和用户体验引入2B领域。
        </h1>
        <div class="archival">
          <li>辽ICP备18012830号-6</li>
          <li>©ekaquan.com</li>
          <li>
            <img src="../assets/archival.png" alt="" /><span
              >辽公网安备 21010502000526号</span
            >
          </li>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CollapsiblePanel from "./CollapsiblePanel.vue";
export default {
  components: {
    CollapsiblePanel,
  },
  data() {
    return {
      arrowRight: require("../assets/arrowRight.png"),
      arrowBottom: require("../assets/arrowBottom1.png"),
    };
  },
  methods: {
    goToPropertie() {
      this.$router.push("/Properties");
    },
    goToImmigration() {
      this.$router.push("/news/immigration");
    },
  },
};
</script>

<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
@media (max-width: 576px) {
  .content {
    display: none;
  }
  .mobile_content {
    display: block !important;
    padding: 5px 32px 25px;
    background: #f7f8fb;
    .introductory {
      display: flex;
      flex-direction: column;
      img {
        width: 187px;
        height: 32px;
        margin: 25px 0;
      }
      h1 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #666666;
        line-height: 17px;
        text-align: left;
        border-bottom: 1px solid #eef1f5;
        padding-bottom: 25px;
      }
      .archival {
        display: flex;
        justify-content: space-between;
        margin-top: 25px;
        li {
          font-family: SourceHanSansCN-ExtraLight-GBpc-EUC-H,
            SourceHanSansCN-ExtraLight-GBpc-EUC-H;
          font-weight: 400;
          font-size: 8px;
          color: #666666;
          text-align: left;
          display: flex;
          // align-items: center;
          img {
            width: 10.06px;
            height: 10.36px;
            margin: 0;
            margin-right: 4px;
          }
        }
      }
    }
  }
}
.footer {
  background: url(../assets/footerBg.png) no-repeat center/cover;
  width: 100%;
}
.content {
  width: 100%;
  max-width: 75rem;
  margin: 0 auto;
  .top {
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      width: 187px;
      height: 32px;
      margin: 45px 0 35px;
    }
    h1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #666666;
      line-height: 17px;
      text-align: center;
      margin-bottom: 48px;
    }
  }
  .bottom {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #eef1f5;
    padding: 35px 0;
    p {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #666666;
    }
  }
}
.mobile_content {
  display: none;
}
</style>
